module.exports = __webpack_public_path__ + "static/MobileImage2-34272d835d1b3ee80ba9a518baf30f5a.png";